export default __webpack_public_path__ + "8a1c084b7c21815f884416a3d9c1fb98.jpg";